<script setup lang="ts">
import { SectionFormElement } from "~/api";

const props = defineProps<{ modelValue: SectionFormElement }>();
</script>

<template>
  <div
    class="SectionComponent"
    :class="{ hide: modelValue.label?.length === 0 }"
  >
    <div v-if="modelValue.label" class="heading-level-0">
      <slot name="label" :element="modelValue" />
    </div>
  </div>
</template>
<style lang="less">
.SectionComponent {
  // copied from Heading.vue
  background-color: var(--el-text-color-primary);
  margin: 0 -6px; // make it slightly wider
  color: #ffffff;
  font-size: 20px; // default size
  margin-left: -15px;

  .heading-level-0 {
    margin-left: 15px;
    font-size: 1em;

    .component-label-comment {
      font-size: 1em;
    }
  }

  &.hide {
    display: none;
  }
}
</style>
